import http from './http'
import {useMessage} from "@/utils/useMessage";
import axios, {Axios, AxiosError, AxiosHeaders, AxiosRequestConfig, AxiosResponse} from "axios";
import type { RequestOptions, Result, UploadFileParams, UploadFileCallBack } from './http/types/axios';

import {CreateAxiosOptions} from "@/utils/http/axios/axiosTransform";
import {cloneDeep} from "lodash-es";
import {isFunction} from "@/utils/is";
import {getHeaders} from "@/utils/common/compUtils";
import {removeSpaces} from "@/utils/utils";
const {createMessage, createConfirm} = useMessage();
/**
 * 导出文件xlsx的mime-type
 */
export const XLSX_MIME_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const PDF_MIME_TYPE = 'application/pdf;charset=utf-8';
export const ZIP_MIME_TYPE = 'application/octet-stream;charset=utf-8';
/**
 * 导出文件xlsx的文件后缀
 */
export const XLSX_FILE_SUFFIX = '.xlsx';
export const PDF_FILE_SUFFIX = '.pdf';
export const ZIP_FILE_SUFFIX = '.zip';

// 封装GET请求
export function get<T>(url: string, params?: any): Promise<T> {

    //去除关键字的空格
    // console.log(params)
    let arr = ['keywords', 'search']
    arr.forEach((item)=>{
        if(params && params[item]){
            params[item] = removeSpaces(params[item]);
        }
    })
    return http.get<T>(url, { params })
        .then(response => response)
        .catch(error => {
            throw error;
        });
}

// 封装POST请求
export function postForm<T>(url: string, params?: Object ): Promise<T> {
    let conf = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
    let data = new FormData()

    if(params){
        for(let key in params){
            data.append(key, params[key])
        }
    }

    return http.postForm<T>(url, data, conf)
        .then(response => response)
        .catch(error => {
            throw error;
    });
}

// 封装POST请求
export function post<T>(url: string, params?: any): Promise<T> {
    return http.post<T>(url, params)
        .then(response => response)
        .catch(error => {
            throw error;
        });
}

// put
export function put<T>(url: string, params?: any): Promise<T> {
    return http.put<T>(url, params)
        .then(response => response)
        .catch(error => {
            throw error;
        });
}
//delete
export function del(url, handleSuccess, record){
    return createConfirm({
        iconType: 'warning',
        title: '确认删除',
        content: '是否删除选中数据',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
            return defDel(url).then((res)=>{
                createMessage.success("删除成功")
                if(null !== handleSuccess){
                    if(null !== record){
                        handleSuccess(record)
                    }else{
                        handleSuccess()
                    }
                }
                return res
            })
        }
    })
}

//delete
export function delConfirm(url, handleSuccess, record, confirm){
    return createConfirm({
        iconType: 'warning',
        title: confirm.title,
        content: confirm.content,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
            return defDel(url).then((res)=>{
                createMessage.success("删除成功")
                if(null !== handleSuccess){
                    if(null !== record){
                        handleSuccess(record)
                    }else{
                        handleSuccess()
                    }
                }
                return res
            })
        }
    })
}

export function defDel<T>(url: string): Promise<T> {
    return http.delete<T>(url)
        .then(response => response)
        .catch(error => {
            throw error;
        });
}

/**
 * 导出xls
 * @param name
 * @param url
 */
export async function exportXls(name, url, params, isXlsx = false) {
    //update-begin---author:wangshuai---date:2024-01-25---for:【QQYUN-8118】导出超时时间设置长点---
    const data = await http.request({
        url: url,
        method: 'POST',
        params,
        responseType: 'blob',
    });
    //update-end---author:wangshuai---date:2024-01-25---for:【QQYUN-8118】导出超时时间设置长点---
    if (!data) {
        createMessage.warning('文件下载失败');
        return;
    }
    if (!name || typeof name != 'string') {
        name = '导出文件';
    }
    let blobOptions = { type: 'application/vnd.ms-excel;charset=utf-8' };
    let fileSuffix = '.xls';
    if (isXlsx === true) {
        blobOptions['type'] = XLSX_MIME_TYPE;
        fileSuffix = XLSX_FILE_SUFFIX;
    }
    if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(new Blob([data], blobOptions), name + fileSuffix);
    } else {
        let url = window.URL.createObjectURL(new Blob([data], blobOptions));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', name + fileSuffix);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
    }
}

/**
 * 导出PDF
 * @param name
 * @param url
 */
export async function exportPdf(name, url, params) {
    //update-begin---author:wangshuai---date:2024-01-25---for:【QQYUN-8118】导出超时时间设置长点---
    const data = await http.request({
        url: url,
        method: 'POST',
        params,
        responseType: 'blob',
    });
    console.log(data)
    //update-end---author:wangshuai---date:2024-01-25---for:【QQYUN-8118】导出超时时间设置长点---
    if (!data) {
        createMessage.warning('文件下载失败');
        return;
    }
    if (!name || typeof name != 'string') {
        name = '下载文件';
    }
    let blobOptions = { type: PDF_MIME_TYPE};

    if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(new Blob([data], blobOptions), name + PDF_FILE_SUFFIX);
    } else {
        let url = window.URL.createObjectURL(new Blob([data], blobOptions));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', name + PDF_FILE_SUFFIX);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
    }
}

/**
 * 导出PDF
 * @param name
 * @param url
 */
export async function exportZip(name, url, params) {
    //update-begin---author:wangshuai---date:2024-01-25---for:【QQYUN-8118】导出超时时间设置长点---
    const data = await http.request({
        url: url,
        method: 'POST',
        params,
        responseType: 'blob',
    });
    console.log(data)
    //update-end---author:wangshuai---date:2024-01-25---for:【QQYUN-8118】导出超时时间设置长点---
    if (!data) {
        createMessage.warning('文件下载失败');
        return;
    }
    if (!name || typeof name != 'string') {
        name = '下载文件';
    }
    let blobOptions = { type: ZIP_MIME_TYPE};

    if (typeof window.navigator.msSaveBlob !== "undefined") {
        window.navigator.msSaveBlob(new Blob([data], blobOptions), name + ZIP_FILE_SUFFIX);
    } else {
        let url = window.URL.createObjectURL(new Blob([data], blobOptions));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', name + ZIP_FILE_SUFFIX);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
    }
}

export function uploadFile<T = any>(config: AxiosRequestConfig, options?: RequestOptions): Promise<T> {
    let conf: CreateAxiosOptions = cloneDeep(config);
    const transform = this.getTransform();

    const { requestOptions } = this.options;

    const opt: RequestOptions = Object.assign({}, requestOptions, options);

    const { beforeRequestHook, requestCatchHook, transformRequestHook } = transform || {};
    if (beforeRequestHook && isFunction(beforeRequestHook)) {
        conf = beforeRequestHook(conf, opt);
    }
    conf.requestOptions = opt;

    conf = this.supportFormData(conf);

    return new Promise((resolve, reject) => {
        this.axiosInstance
            .request<any, AxiosResponse<Result>>(conf)
            .then((res: AxiosResponse<Result>) => {
                if (transformRequestHook && isFunction(transformRequestHook)) {
                    try {
                        const ret = transformRequestHook(res, opt);
                        //zhangyafei---添加回调方法
                        config.success && config.success(res.data);
                        //zhangyafei---添加回调方法
                        resolve(ret);
                    } catch (err) {
                        reject(err || new Error('request error!'));
                    }
                    return;
                }
                resolve(res as unknown as Promise<T>);
            })
            .catch((e: Error | AxiosError) => {
                if (requestCatchHook && isFunction(requestCatchHook)) {
                    reject(requestCatchHook(e, opt));
                    return;
                }
                if (axios.isAxiosError(e)) {
                    // 在此处重写来自axios的错误消息
                }
                reject(e);
            });
    });
}



